export default __webpack_public_path__ + "static/media/event-6.88209f1a.jpg";